import type { EasingName } from '../config/player.config';

export type EasingFunction = (t: number) => number;

export const EASINGS: Readonly<Record<EasingName, EasingFunction>> = {
  linear: (t) => t,
  easeOutQuad: (t) => 1 - (1 - t) * (1 - t),
  easeOutCubic: (t) => 1 - (1 - t) ** 3,
  easeInOutSine: (t) => -(Math.cos(Math.PI * t) - 1) / 2,
};
